import React from 'react';

import { contentTypes, isToRenderContent } from '../helper';
import { isValidStringLength } from '@nykaa/auth-shared/utils';
import { transformDate } from '@nykaa/seo/utils';
import { PriceListProps } from '.';
import { Row, Wrapper } from './styled';
import { LAST_UPDATED, PRICE, PRICE_LIST } from '@nykaa/seo/constants';

const PriceList = ({ pageType, Bestsellers, title }: PriceListProps) => {
  if (!isToRenderContent(pageType, contentTypes.PriceList)) {
    return null;
  }

  const formattedDate = transformDate(new Date());
  return (
    <>
      {isValidStringLength(title) && (
        <Wrapper>
          <h2>{`${title} ${PRICE_LIST}`}</h2>
          <table>
            <caption>{`${title} ${PRICE_LIST} - Product names and prices as of ${formattedDate}`}</caption>
            <thead>
              <Row>
                <th
                  scope="col"
                  className="titleColumn"
                >
                  <span className="heading name">{title}</span>
                </th>
                <th
                  scope="col"
                  className="priceColumn"
                >
                  <span className="heading">{PRICE}</span>
                </th>
              </Row>
            </thead>
            <tbody>
              {Bestsellers &&
                Bestsellers.map((product) => {
                  let { link = '', name = '', price } = product;
                  let modifiedProductUrl = link.replace('id', 'productId');

                  return (
                    <Row key={`priceList_${name}`}>
                      <th
                        scope="row"
                        className="titleColumn"
                      >
                        <a href={modifiedProductUrl}>
                          <span>{name}</span>
                        </a>
                      </th>
                      <td className="priceColumn">
                        <span>&#8377;{price}</span>
                      </td>
                    </Row>
                  );
                })}
            </tbody>
          </table>
          <Row className="last-update">{`${LAST_UPDATED}${formattedDate}`}</Row>
        </Wrapper>
      )}
    </>
  );
};

export default PriceList;
